import PictureFormContainer from './PictureFormContainer';
export default PictureFormContainer;
